import React, { useEffect, useRef } from 'react';
import { CSSTransition as Transition } from 'react-transition-group';
import CBSpinner from '@cb/apricot/CBSpinner';
import { useUID } from 'react-uid';
import cn from 'classnames';
export const spinnerPalette = ['blue5', 'blue2', 'green1', 'purple1'];
export const spinnerSize = ['16', '24', '32', '64'];
const CSSTransition = ({ children, shouldMount = true, timeout = 500, className = 'cb-css-transition' }) => (React.createElement(Transition, { in: shouldMount, unmountOnExit: true, timeout: timeout, classNames: className }, children));
export const Spinner = ({ spinnerId, show = true, ariaLabel = 'Loading ...', className, light = false, timeout = 500, duration, min, max, end, palette, size, text, animated = false, progress = false, suffix, transitionClassName = 'cb-css-transition', }) => {
    const uid = useUID();
    // eslint-disable-next-line no-param-reassign
    spinnerId = spinnerId || `apricot_spinner_${uid}`;
    const spinnerClassName = cn(`cb-spinner`, light && `cb-spinner-light`, className, palette && `cb-palette-${palette}`, size && `cb-spinner-${size}`);
    const progressClassName = cn(`cb-progress-spinner`, palette && `cb-palette-${palette}`);
    const spinnerRef = useRef(null);
    const getRole = () => {
        if (animated)
            return 'progressbar';
        return progress ? 'img' : 'status';
    };
    const role = getRole();
    const staticSpinner = !animated && !progress;
    const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);
    useEffect(() => {
        const spinnerAnimatedPlugin = animated &&
            CBSpinner.Animated(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ elem: spinnerRef.current }, (duration && { duration })), (min && { min })), (max && { max })), (end && { end })), (suffix && { suffix })));
        return () => {
            spinnerAnimatedPlugin && spinnerAnimatedPlugin.destroy();
        };
    }, [animated, text, suffix, duration, end, min, max, palette]);
    useEffect(() => {
        const spinnerProgressPlugin = progress &&
            CBSpinner.Progress(Object.assign(Object.assign(Object.assign({ elem: spinnerRef.current }, (suffix && { suffix })), (duration && { duration })), (end && { end })));
        return () => {
            spinnerProgressPlugin && spinnerProgressPlugin.destroy();
        };
    }, [progress, suffix, duration, end, text, palette]);
    /* eslint-disable react/no-unstable-nested-components */
    return (React.createElement(CSSTransition, { shouldMount: show, timeout: timeout, className: transitionClassName },
        React.createElement("div", Object.assign({ role: role }, (staticSpinner ? { 'aria-labelledby': spinnerId } : {}), { className: progress ? progressClassName : undefined, "data-cbtrack-comp": "apricot-react:spinner", ref: spinnerRef }),
            React.createElement("span", { className: "ms-high-contrast" }, "Loading"),
            React.createElement(ConditionalWrapper, { condition: !progress, wrapper: children => (React.createElement("div", { className: spinnerClassName, id: spinnerId, role: !animated ? 'img' : undefined, "aria-label": ariaLabel }, children)) },
                progress && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "cb-spinner-background" }),
                    React.createElement("div", { className: "cb-spinner-rotate" }),
                    React.createElement("div", { className: "cb-spinner-right" }),
                    React.createElement("div", { className: "cb-spinner-left" }))),
                React.createElement("p", { className: "cb-spinner-indicator" },
                    text,
                    suffix),
                !progress &&
                    Array(12)
                        .fill(null)
                        .map((el, i) => React.createElement("div", { key: i }))))));
};
//# sourceMappingURL=Spinner.js.map